import React from "react";
import { loader } from "graphql.macro";
import { Query } from "react-apollo";
import ReactHtmlParser from "react-html-parser";

// import functions
import truncate from "../../../util/truncate";

// import styled components
import { Spinner } from "../../styled";
import {
  ReviewsContainer,
  ReviewsEntry,
  ReviewsRow,
  ReviewsWrapper,
} from "./styled";

// load graphql query
const GET_REVIEWS_QUERY = loader("../../../graphql/GET_REVIEWS_QUERY.graphql");

function Reviews() {
  const staticReviews = [
    {
      id: "beth-review-1",
      rating: 5,
      comments:
        "Beth Tullis is highly professional and knowledgeable. She was a pleasure to work with and went above and beyond to secure a loan for us and our new property. She was with us every step of the way. We would highly recommend Beth Tullis for your mortgage needs.",
      url: "",
      date: "",
      reviewer: {
        firstName: "Crystal",
        lastName: "A",
        __typename: "Reviewer",
      },
      __typename: "Review",
    },
    {
      id: "beth-review-2",
      rating: 5,
      comments:
        "We have worked with Beth Tullis for two mortgage loans. She is extremely knowledgeable and thorough. She is excellent at keeping her clients informed of each step along the way. I can't recommend her highly enough!!",
      url: "",
      date: "",
      reviewer: {
        firstName: "Terri",
        lastName: "M",
        __typename: "Reviewer",
      },
      __typename: "Review",
    },
    {
      id: "beth-review-3",
      rating: 5,
      comments:
        "Buying a house is one of the most stressful events of my life, but Beth made the process 100% worth it. She is knowledgeable, caring, hardworking, and genuine. I would recommend Beth to ANYONE!",
      url: "",
      date: "",
      reviewer: {
        firstName: "Melissa",
        lastName: "S",
        __typename: "Reviewer",
      },
      __typename: "Review",
    },
  ];

  const mapReviews = (reviews) => {
    const maxLength = 550;
    let counter = 0;

    return reviews.map((review, i) => {
      const { comments, date, id, rating, reviewer, url } = review;
      let content = "";
      let showUrl = false;
      let stars = "";

      if (!comments) return null;

      if (counter < 3) {
        counter = counter + 1;

        if (comments.length > maxLength) {
          content = truncate(comments, maxLength);
          showUrl = true;
        } else {
          content = comments;
        }

        for (let j = 0; j < rating; j++) {
          stars += "&#9733;";
        }

        return (
          <ReviewsEntry key={id}>
            <p id="reviewBody">{content}</p>
          
            <div>
              <span>{ReactHtmlParser(stars)}</span>
              <p>
                <strong>{`${reviewer.firstName} ${reviewer.lastName
                  .charAt(0)
                  .toUpperCase()}.`}</strong>
              </p>
            </div>
          </ReviewsEntry>
        );
      }
      return null;
    });
  };
  return (
    <ReviewsWrapper id="nav-reviews">
      <ReviewsContainer>
        <h2>What Customers Said About Us</h2>
        
        {/* <Query query={GET_REVIEWS_QUERY}>
          {({ data, error, loading }) => {
            if (loading) return <Spinner />;

            if (error) {
              console.log(error);
              return "Error loading reviews...";
            }

            const {
              reviewsList: { reviews },
            } = data;
            console.log(newReviews);

            return <ReviewsRow>{mapReviews(newReviews)}</ReviewsRow>;
          }}
        </Query> */}
        <ReviewsRow>{mapReviews(staticReviews)}</ReviewsRow>
      </ReviewsContainer>
    </ReviewsWrapper>
  );
}

export default Reviews;
